import * as React from 'react';

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        name: '',
        email: '',
        message: ''
      },
      errors: {},
      isSubmitting: false,
      submitStatus: null
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value
      },
      // Clear error when user types
      errors: {
        ...prevState.errors,
        [name]: null
      }
    }));
  };

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};
    let isValid = true;

    if (!formData.name.trim()) {
      errors.name = 'Name is required';
      isValid = false;
    }

    if (!formData.email) {
      errors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      errors.email = 'Please enter a valid email address';
      isValid = false;
    }

    if (!formData.message.trim()) {
      errors.message = 'Message is required';
      isValid = false;
    }

    this.setState({ errors });
    return isValid;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!this.validateForm()) {
      return;
    }

    this.setState({ isSubmitting: true });

    try {
      const form = e.target;
      const formData = new FormData(form);
      
      const response = await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData).toString()
      });

      if (response.ok) {
        this.setState({
          submitStatus: 'success',
          formData: { name: '', email: '', message: '' }
        });
      } else {
        throw new Error('Network response was not ok');
      }
    } catch (error) {
      this.setState({ submitStatus: 'error' });
      console.error('Form submission error:', error);
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  render() {
    const { formData, errors, isSubmitting, submitStatus } = this.state;

    return (
      <div id="contact" className="text-center panel">
      <div className="panel-content">
        <h2 className="text-center">Contact</h2>
        
        
        {submitStatus === 'success' ? (
          <div>
            Thank you for your message! We'll get back to you soon.
          </div>
        ) : (
          <form 
            name="websiteContact" 
            method="POST" 
            data-netlify="true"
            onSubmit={this.handleSubmit}
            noValidate
          >
            <input type="hidden" name="form-name" value="websiteContact" />
            
            <div className="form-group">
              <label htmlFor="name">Name *</label>
              <input
                type="text"
                id="name"
                placeholder="Your Name"
                name="name"
                value={formData.name}
                onChange={this.handleChange}
                aria-invalid={!!errors.name}
                aria-describedby={errors.name ? 'name-error' : undefined}
                required
              />
              {errors.name && (
                <span id="name-error">
                  {errors.name}
                </span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                type="email"
                id="email"
                placeholder="Your Email"
                name="email"
                value={formData.email}
                onChange={this.handleChange}
                aria-invalid={!!errors.email}
                aria-describedby={errors.email ? 'email-error' : undefined}
                required
              />
              {errors.email && (
                <span id="email-error" className={styles.errorMessage}>
                  {errors.email}
                </span>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                placeholder="Your Message"
                name="message"
                rows="5"
                value={formData.message}
                onChange={this.handleChange}
                aria-invalid={!!errors.message}
                aria-describedby={errors.message ? 'message-error' : undefined}
                required
              />
              {errors.message && (
                <span id="message-error" className={styles.errorMessage}>
                  {errors.message}
                </span>
              )}
            </div>

            <button 
              type="submit" 
              className="btn btn-blue"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>

            {submitStatus === 'error' && (
              <div style={{ marginTop: '1rem' }}>
                There was an error submitting the form. Please try again later.
              </div>
            )}
          </form>
        )}
      </div>
      </div>
    );
  }
}

export default ContactForm;